module.exports = __webpack_public_path__ + "assets/img/rule.cb5fdbcc.png";